import { render, staticRenderFns } from "./GenericFooter.vue?vue&type=template&id=25792522&"
import script from "./GenericFooter.vue?vue&type=script&lang=js&"
export * from "./GenericFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports